



import mitt from 'mitt';
import { ISignupData } from '@/interfaces/Auth/ISignupData';



type Events = {
  'open-auth-dialog': void;
  'close-auth-dialog': void;
  'signup-verification-email-sent': ISignupData;
  'signup-verification-email-link-received': string;
  'signup-verification-email-verified': void;
};



const authEvents = mitt<Events>();

export default authEvents; 